module.exports = __webpack_public_path__ + "src/img/xy.017d9f6f.svg";